import { money } from "@/lib/api";

const colors = {
  Fuel: "bg-orange-100 text-orange-800 dark:bg-orange-950/50 dark:text-orange-300",
  Equipment: "bg-sky-100 text-sky-800 dark:bg-sky-950/50 dark:text-sky-300",
  Supplies: "bg-lime-100 text-lime-800 dark:bg-lime-950/50 dark:text-lime-300",
  "Repairs & Maintenance": "bg-rose-100 text-rose-800 dark:bg-rose-950/50 dark:text-rose-300",
  Vehicle: "bg-violet-100 text-violet-800 dark:bg-violet-950/50 dark:text-violet-300",
  Insurance: "bg-teal-100 text-teal-800 dark:bg-teal-950/50 dark:text-teal-300",
  Marketing: "bg-pink-100 text-pink-800 dark:bg-pink-950/50 dark:text-pink-300",
  Office: "bg-indigo-100 text-indigo-800 dark:bg-indigo-950/50 dark:text-indigo-300",
  Meals: "bg-yellow-100 text-yellow-800 dark:bg-yellow-950/50 dark:text-yellow-300",
  Other: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
};

export const CategoryBadge = ({ category }) => (
  <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${colors[category] || colors.Other}`}>{category || "Other"}</span>
);

export const CategoryTotals = ({ title, rows, total, testId }) => (
  <div className="surface overflow-x-auto" data-testid={testId}>
    <div className="px-4 pt-4"><h2 className="text-lg font-semibold">{title}</h2></div>
    <table className="w-full text-sm mt-2">
      <thead>
        <tr className="border-b border-border text-xs font-bold uppercase tracking-wider text-muted-foreground text-left">
          <th className="px-4 py-2">Category</th><th className="px-4 py-2 text-right">Entries</th><th className="px-4 py-2 text-right">Spent</th><th className="px-4 py-2 text-right">Share</th>
        </tr>
      </thead>
      <tbody>
        {rows.length === 0 && <tr><td colSpan={4} className="px-4 py-6 text-muted-foreground">Nothing logged yet.</td></tr>}
        {[...rows].sort((a, b) => b.total - a.total).map((r) => (
          <tr key={r.category} data-testid={`${testId}-row-${r.category.replace(/[^a-z]/gi, "").toLowerCase()}`} className="border-b border-border last:border-0">
            <td className="px-4 py-2"><CategoryBadge category={r.category} /></td>
            <td className="px-4 py-2 text-right font-mono">{r.count}</td>
            <td className="px-4 py-2 text-right font-mono font-semibold">{money(r.total)}</td>
            <td className="px-4 py-2 text-right font-mono text-muted-foreground">{total ? Math.round((r.total / total) * 100) : 0}%</td>
          </tr>
        ))}
      </tbody>
      {rows.length > 0 && (
        <tfoot>
          <tr className="border-t-2 border-slate-900 dark:border-slate-200 font-bold">
            <td className="px-4 py-3">Total</td>
            <td className="px-4 py-3 text-right font-mono">{rows.reduce((s, r) => s + r.count, 0)}</td>
            <td className="px-4 py-3 text-right font-mono">{money(total)}</td>
            <td className="px-4 py-3 text-right font-mono">100%</td>
          </tr>
        </tfoot>
      )}
    </table>
  </div>
);
